import { Box } from "@mui/material";

const EmptyFilterBody = () => <Box sx={(t) => ({ height: t.spacing(4.6) })} />;

export default EmptyFilterBody;
